// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"47":"e0370a10","50":"95d46a5d","83":"a38b752b","231":"46c8202b","247":"b824c609","337":"eb2a2639","666":"3c02062a","672":"25920a6d","695":"a4c2bba6","704":"f52c275c","805":"70ad5229","849":"43ccb995","896":"1fe725a6"}[chunkId] + ".js";
};